// Generates a custom element where admins can adjust associated auto groups for webhooks and audio files
// This was copied from the groups/groups_detail_row.js
class RateScheduleGroupIndustries extends HTMLElement {
  constructor() {
    super();
  }

  async connectedCallback() {
    this.innerHTML = "Loading...";

    // Industry data
    let industry_data_binder = new DataBinder("/admin/industries.json", true);
    await industry_data_binder.fetchData();
    this.industry_data = industry_data_binder.data;    

    // remove any selected industries from the menu options
    this.current_selected_industries.map(industry_id => {
      this.markOptionAsSelected(industry_id)
    })
  
    this.refresh()
  }

  refresh() {
    const current_industry_options = this.industry_data.filter(industry => {
      return industry.selected !== true
    })
    
    const industry_options = current_industry_options.map(industry => `<option value="${industry.id}">${industry.display_name}</option>`).join("");

    // gets current selected industry names from list of industries
    this.selected_industry_data = this.industry_data.filter(industry => this.current_selected_industries.includes(industry.id))

    this.selected_industry_pills = this.selected_industry_data.map(industry => `<div class='badge badge-pill badge-info'>${industry.display_name} <span class="fas fa-times remove-industry" data-id="${industry.id}"></span></div>`).join('')

    this.label_text = this.label_text || "Industries"

    this.innerHTML =     
    `
    <style>
      #edit-user-back {
        font-family: "FontAwesome";
        font-weight: normal;
      }

      #edit-user-back:hover {
        cursor: pointer;
      }

      #edit-group-user {
        width: 75%;
        margin: 0 auto;
      }

      .edit-industry-pills {
        margin-bottom: 5px;
      }

      .edit-industry-pills h5 {
        margin-bottom: 20px;
      }
      
      .edit-user-buttons {
        margin-top: 20px;
      }

      .edit-user-div {
        margin: 20px 0;
      }

      .edit-industry-pills .badge {
        margin: 3px 5px 3px 0;
      }

      .edit-industry-pills .fas {
        font-family: FontAwesome;
      }

      .edit-industry-pills .fa-times:hover {
        cursor: pointer;
      }

      .edit-industry-pills h4 {
        font-weight: 600;
      }
    </style> 
    <div class="row">
      <div class="form-group" >
        <label for="edit-industry-select">${this.label_text}</label>
        <div class="edit-industry-pills">
          ${this.selected_industry_pills}
        </div>
        <select id="edit-industry-select" class="form-control">
          <option value=null>Select industries...</option>
          ${industry_options} 
        </select>
      </div>
    </div>
  `;
    
    this.querySelector('#edit-industry-select').onchange = (e) => {this.addIndustry(e.target, e.target.value)}

    this.querySelectorAll('.remove-industry').forEach(button => {
      button.addEventListener('click', function(e) {
        this.removeIndustry(e.target.dataset.id)
      }.bind(this));
    })  
  }

  // When an industry is selected, we remove it from the options by
  // marking it as selected, and adding the selected industry to the
  // attribute for rendering the pills. Then we refresh the ui.
  addIndustry(target, id) {
    // this.selected_industry_data <= all selected industries
    // this.industry_data <= json data from the server
    // this.current_selected_industries <= array of selected industry ids

    let industryId = parseInt(id);
    if(industryId && !this.selected_industry_data.some(e => e.id == industryId)) {
      this.current_selected_industries.push(industryId)
      this.markOptionAsSelected(industryId)
      this.refresh()
      this.broadcast_changes()
    }
  }

  removeIndustry(id) {
    if (! this.allow_all_industries) {
      if(this.current_selected_industries.length === 1) {
        Common.notify('At least one industry must be selected.', 'danger')
        return
      }
    }
    
    let industryId = parseInt(id);

    const id_index = this.current_selected_industries.indexOf(industryId)
    if (id_index > -1){
      this.current_selected_industries.splice(id_index, 1)
    }

    // This will re-enable the menu option for the removed industry
    this.industry_data.map(industry => {
      if (industry.id === industryId) {
        industry.selected = false
      }
    })
    this.refresh()

    this.broadcast_changes()
  }

  broadcast_changes() {
    this.dispatchEvent(new CustomEvent('selected_industries_changed', 
      {bubbles: true, composed: true, detail: {selected_industries: this.selectedIndustries()}}
    ))  
  }
  
  markOptionAsSelected(id){
    let industryId = parseInt(id);
      this.industry_data.map(industry => {
        if (industry.id === industryId) {
          industry.selected = true
        }
      })
  
  }
  
  selectedIndustries() {        
    return this.current_selected_industries
  }

  showError(){
    this.querySelector("#edit-industry-select").classList.add("error")
  }

  removeError(){
    this.querySelector("#edit-industry-select").classList.remove("error")
  }
}

customElements.define("rate-schedule-group-industries", RateScheduleGroupIndustries);